import { useQuery } from '@tanstack/react-query';
import { getOrderEvents, eventsQueryKeys } from '@api/events';

export function useOrderEvents(orderId: number) {
  return useQuery({
    queryKey: eventsQueryKeys.orderEvents(orderId),
    queryFn: () => getOrderEvents(orderId),
    staleTime: 30_000,
  });
}
